// landing.page.ts
import { Component, OnInit } from "@angular/core";
import { NavController, LoadingController } from "@ionic/angular";
import { Storage } from "@ionic/storage-angular";
import { UsuariosService } from "../../services/usuarios.service";

@Component({
  selector: "app-landing",
  templateUrl: "./landing.page.html",
  styleUrls: ["./landing.page.scss"],
})
export class LandingPage implements OnInit {

  constructor(
    private navCtrl: NavController,
    private loadingCtrl: LoadingController,
    private storage: Storage,
    public usuariosService: UsuariosService
  ) {}

  ngOnInit() {
    this.logado();
  }

  async logado() {
    const token = await this.storage.get("token");
    if (token) {
      const stored = await this.storage.get("usuario");
      const response = JSON.parse(stored);
      this.usuariosService.usuario.nome   = response.username;
      this.usuariosService.usuario.email  = response.email;
      this.usuariosService.usuario.sobre  = response.sobre;
      this.usuariosService.usuario.avatar = response.avatar;

      // aqui, inclui o /app antes de me
      this.navCtrl.navigateRoot("/app/me");
    } else {
      this.navCtrl.navigateRoot("/login");
    }
  }

  async goToExplore() {
    const loading = await this.loadingCtrl.create({
      message: "Entrando...",
      translucent: true,
    });
    await loading.present();

    setTimeout(async () => {
      await loading.dismiss();
      // idem aqui: /app/me
      await this.navCtrl.navigateRoot("/app/me");
    }, 1000);
  }
}
